export default __webpack_public_path__ + "static/media/big_head_-3.c4e64149.webp";